import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ForeignEntityRegistration from "@/pages/ForeignEntityRegistration";
import AuditAssurance from "@/pages/AuditAssurance";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/services/foreign-entity-registration"
            element={<ForeignEntityRegistration />}
          />
          <Route path="/services/audit-assurance" element={<AuditAssurance />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1B3B2B",
            color: "#FDFBF7",
            border: "1px solid #D4AF37",
            borderRadius: 2,
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
